Service = App.loadClass 'core::Angular/Service'

class exports.FieldprintService extends Service
    constructor: (@http, @state, @rootScope) ->
        @reset()
        @config = {}
        @phosphorousDisabledHoverMessage = 'These inputs do not apply because you did not add phosphorous to the Fertilizer form on Step 1.'
        @phosphorousDrawdownDisabledHoverMessage = 'These options are not available unless the "Excessive/Very High" option is selected for the phosphorous soil test level input.'
        @year = moment().format 'YYYY'
        @crop = null
        @mfCrop = null
        @field = null
        @onSaveTriggers = []
        @rootScope.fpcTriggerMissing = 0
        @phosphorousAndNitrogenUsage = null
        @loadConfig()

        @http.get('backend/grower/fieldprint/validation-values').then (response) =>
            @validationCropValues = response.data.crop
            @validationIrrigationValues = response.data.irrigation

        @getCrops().then (response) =>
            @crops = response.data.data

        Socket.register 'reloadIrrigationImage', (data) =>
            if @fpcResult?.field?.id is data.fieldId
                @getBoundaryImage?()

        @http.get('backend/user-info/company').then (response) =>
            @hasSaifsaOtherPractices = response.data.company_configuration.has_saifsa_other_practices

    reset: () =>
        @id = null
        # Don't reset things that the sidebar uses
        # @year = null
        # @crop = null
        # @field = null
        @fpcResult = {}
        @currentStepIndex = 0
        @currentStepName = ''
        @visitedSteps = []
        @savedSteps = []
        @brandNew = false
        @completenessElements = {}
        @showIncompletenessMessage = false
        @changeStepFromSidebar = false
        @hasPBIConnection = false
        @isFieldLinkedExternally = false
        @isFieldLinkedUploadedPbi = false
        @phosphorousAndNitrogenUsage = null

        # Reset the crops and config since the user may have changed company experiences
        @getCrops().then (response) =>
            @crops = response.data.data
        @loadConfig()

    onDataLoaded: (scope, callback) =>
        handler = @rootScope.$on 'fieldprint-loaded', callback
        scope.$on '$destroy', handler

        if Object.keys(@fpcResult).length
            # @rootScope.$emit 'fieldprint-loaded'
            callback()

    loadConfig: () =>
        @http.get('backend/grower/fieldprint/config').then (response) =>
            @config = response.data

    checkOtherPractices: () =>
        @http.post 'backend/grower/other-practices/exists',
            year: @year,
            crop: @crop
        .then (response) =>
            @hasOtherPractices = parseInt(response.data)

    getDefaults: (config) =>
        defaults = {}

        for key, value of config
            if value.value?.default?
                # Hack to get around the MakeAssoicativeArayJsonable Job
                # If we want to default to an array, the array itself is turned into an
                # associative array, along with its values also turned into associative arrays?
                # of zero-length.
                #
                # The below just checks if the default value is object and not array (b/c arrays are objects)
                # then just treats the object keys as the array we want to default to.
                if not Array.isArray(value.value.default.value) and value.value.default.value instanceof Object
                    defaults[key] = Object.keys(value.value.default.value)
                else
                    defaults[key] = value.value.default.value

            if value isnt null and typeof value is 'object'
                angular.extend defaults, @getDefaults(value)

        return defaults

    getYears: () =>
        return @http.get('backend/grower/data/ng-get-all-years')

    getCrops: () =>
        return @http.get('backend/grower/fieldprint/crops')

    getAllCrops: () =>
        return @http.get('backend/grower/fieldprint/all-crops')

    getPreviousFieldprintCropYield: () =>
        @http.get 'backend/grower/fieldprint/fieldprint-crop-yield',
            params: {
                year: @year - 1
                field_id: @field
            }
        .then (response) =>
            @previousFieldprintCropYield = response.data

    getBoundaryImage: () =>
        @http.post 'backend/grower/fieldprint/boundary-image', { fpcResultId: @fpcResult.id }
        .then (response) =>
            @imagePath = "backend/grower/download/load-image?path=#{response.data}&cachebust=#{Math.random()}"

    getFieldLinkedExternally: () =>
        @http.get 'backend/grower/pbi/field-linked-external/' + @field,
            params: {
                year: @year
            }
        .then (response) =>
            @isFieldLinkedExternally = response.data

    getFieldLinkedUploadedPbi: () =>
        @http.get 'backend/grower/pbi/field-linked-uploaded-pbi/' + @field,
            params: {
                year: @year
            }
        .then (response) =>
            @isFieldLinkedUploadedPbi = response.data

    getPBIConnection: () =>
        @http.get('backend/grower/pbi/has-connection', { params: { @year } })
        .then (response) =>
            @hasPBIConnection = response.data.has_connection

    loadFieldBoundary: (fieldId) =>
        if not App.layer_store.exists fieldId
            App.layer_store.empty()
            App.layer_store.loadField fieldId, { fillOpacity: 0.0 }

    createFieldprint: (year, crop, field) =>
        @year = year
        @crop = crop
        @field = field

        @checkOtherPractices()

        @http.post 'backend/grower/fieldprint/create', { year, crop, field }

    loadFieldprint: (id) =>
        @http.get("backend/grower/fieldprint/#{id}")
        .then (response) =>
            @year = response.data.year
            @crop = response.data.ftm_crop.name
            @mfCrop = response.data.crop.name
            @field = response.data.fields_id
            @fpcResult = response.data

            # constrain defaults by crop
            defaults = @getDefaults @config[@crop]
            @fpcResult.data = angular.extend {}, defaults, @fpcResult.data

            @getBoundaryImage()
            # get data for previous crop dropdown
            @getAllCrops().then (response) =>
                @allCrops = response.data
            @getPreviousFieldprintCropYield()
            @getFieldLinkedExternally()
            @getFieldLinkedUploadedPbi()
            @getPBIConnection()
            @visitedSteps = response.data.visited_steps
            @savedSteps = response.data.saved_steps

            # @dataLoaded.resolve()
            @rootScope.$emit 'fieldprint-loaded'

            @checkOtherPractices()

    triggerMissing: (stepNumber) =>
        if stepNumber > @currentStepIndex
            if @fpcResult.completeness.steps[@currentStepName] is false
                @rootScope.fpcTriggerMissing++
                return true
        return false

    gotoStep: (stepNumber, id, saveData = true, fromSidebar = false, goingToFirstIncompleteStep = false) =>
        # moveStep() was separated out because of checking the response gives us a promise and would have ran this code
        # everytime, we separated it into its own function to control when it gets called after the promise so it can be called after the promise resloves,
        # and to run if the N or P isn't there to run and to step through the steps normally.
        moveStep = () =>
            @changeStepFromSidebar = fromSidebar
            if not id
                id = @state.params.id

            if not id
                throw new Error("FPC: Going to step #{stepNumber} but no fpc result id specified!")

            if saveData
                @save id

            if @triggerMissing stepNumber
                @showIncompletenessMessage = true
                return

            @showIncompletenessMessage = false

            @currentStepIndex = stepNumber
            @currentStepName = _.findKey @config[@crop].steps.value, (obj) =>
                obj.order is stepNumber

            if @currentStepName
                currentStepName = @currentStepName
                @http.post "backend/grower/fieldprint/#{id}/step/#{currentStepName}/visited"
                @visitedSteps.push currentStepName
            @state.go 'grower.fieldprint.step', { id: id, step: stepNumber + 1 }
        # checks for step 2('1'), passes the correct data for the backend call
        if stepNumber is 1
            @http.get 'backend/grower/fieldprint/nitrogen-or-phosphorus',
                params: {
                    year: @fpcResult.year
                    fieldId: @fpcResult.field.id
                    crop: @fpcResult.crop.name
                }
            .then (response) =>
                @phosphorousAndNitrogenUsage = response.data

                # if we enter step 2 and don't have phosphorous, unset the phosphorous data
                if (not response.data.phosphorous_applied)
                    @fpcResult.data.years_phosphorous_applicable = null
                    @fpcResult.data.conducted_soil_test = false
                    @fpcResult.data.phosphorous_soil_test_level = null

                # if the respnse data shows no N or P then skip this step
                if response.data.nitrogen_applied is false and response.data.phosphorous_applied is false
                    # if we're trying to go to the first incomplete step and it was nutrient management tools but that step is disabled...
                    if goingToFirstIncompleteStep
                        # go to the first incomplete step that is not this disabled/skipped step
                        @goToFirstIncompleteStep(id, true)
                        return

                    # checks the currentStepIndex before it gets re-assigned below, this is the check the direction the user is going through the steps
                    # if no N or P is found we need to skip up to step 3, and in return down from step 3 to step 1
                    if stepNumber is 1 and @currentStepIndex is 0
                        stepNumber += 1
                    else if stepNumber is 1 and @currentStepIndex is 2
                        stepNumber -= 1

                # calls moveStep() after the promise
                moveStep()
        else
            # calls moveStep() like normal when no N or P is found
            moveStep()

    findStepIndexByName: (stepName) =>
        @config[@crop].steps.value[stepName]['order']

    copy: (id, fields) =>
        return @http.post "backend/grower/fieldprint/#{id}/copy", { fields }

    save: (id) =>
        for onSaveFn in @onSaveTriggers
            onSaveFn()

        if @currentStepName
            currentStepName = @currentStepName
            @http.post "backend/grower/fieldprint/#{id}/step/#{currentStepName}/saved"
            @savedSteps.push currentStepName

        @http.post "backend/grower/fieldprint/#{id}/save", @fpcResult.data

    updateCompletenessFor: (element, inputName) =>
        @completenessElements[inputName] = element

    calculateCompleteness: () =>
        if not @fpcResult.id
            return

        return @http.post "backend/grower/fieldprint/#{@fpcResult.id}/completeness",
            data: @fpcResult.data
        .then (response) =>
            @fpcResult.completeness = response.data

            anyErrors = false
            for inputName, element of @completenessElements
                if @fpcResult.completeness.inputs[inputName]? and @fpcResult.completeness.inputs[inputName]
                    element.removeClass 'missing'
                else
                    element.addClass 'missing'
                    anyErrors = true

            if not anyErrors
                @showIncompletenessMessage = false

    irrigationValidationValues: () =>
        return if @validationIrrigationValues[@crop] then @validationIrrigationValues[@crop] else @validationIrrigationValues['default']

    calculatorSucceeded: (fpcResult = @fpcResult) =>
        return fpcResult.dryland_status is 'success' and fpcResult.irrigated_status is 'success'

    calculatorFailed: (fpcResult = @fpcResult) =>
        return fpcResult.dryland_status is 'failed' or fpcResult.irrigated_status is 'failed'

    calculatorPending: (fpcResult = @fpcResult) =>
        return fpcResult.dryland_status is 'pending' or fpcResult.irrigated_status is 'pending'

    calculatorErrored: (fpcResult = @fpcResult) =>
        return fpcResult.dryland_status.startsWith('error') or fpcResult.irrigated_status.startsWith('error')

    badSoils: (fpcResult = @fpcResult) =>
        return fpcResult.dryland_status.indexOf('Missing param: slope_length') >= 0 or fpcResult.irrigated_status.indexOf('Missing param: slope_length') >= 0

    badClimate: (fpcResult = @fpcResult) =>
        return not @badSoils() and (fpcResult.dryland_status.indexOf('No climate zones') >= 0 or fpcResult.irrigated_status.indexOf('No climate zones') >= 0)

    badPlantableAcres: (fpcResult = @fpcResult) =>
        return not @badClimate() and (fpcResult.dryland_status.indexOf('plantable_acres exceeds 10%') >= 0 or fpcResult.irrigated_status.indexOf('plantable_acres exceeds 10%') >= 0)

    badMyFarms: (fpcResult = @fpcResult) =>
        return not @badPlantableAcres(fpcResult)

    badGeometry: () =>
        return @fpcResult.dryland_status.indexOf('Invalid geometry passed to createGISObject') >= 0 or @fpcResult.irrigated_status.indexOf('Invalid geometry passed to createGISObject') >= 0

    hasCoverCropEvents: () =>
        return not not @fpcResult.events['cover_crop']?.length

    getManagementTechniquesDefaults: () =>
        # Get the info for fertilizer sources from the backend
        @http.get 'backend/grower/fieldprint/management-techniques-defaults',
            params: {
                layer_ids: JSON.stringify(@fpcResult.events['fertilizer'])
            }
        .then (response) =>
            # We want to add these values given the following circumstances
            # if the source is slow_release - Nutrient Application Form - Slow or Time Release Nitrogen Fertilizers
            # if the source is a urease inhibitor or a nitrification + urease inhibitor - Nutrient Application Form - Urease Inhibitors
            # if the source is a nitrification inhibitor or a nitrification + urease inhibitor - Nutrient Application Form - Nitrification Inhibitors
            for key, inhibitor of response.data.inhibitors
                if inhibitor is 'Urease' or inhibitor is 'Nitrification + Urease'
                    @fpcResult.data['nutrient_management_techniques'].push 'Nutrient Application Form - Urease Inhibitors'
                if inhibitor is 'Nitrification' or inhibitor is 'Nitrification + Urease'
                    @fpcResult.data['nutrient_management_techniques'].push 'Nutrient Application Form - Nitrification Inhibitors'

            if response.data.slow_release
                @fpcResult.data['nutrient_management_techniques'].push 'Nutrient Application Form - Slow or Time Release Nitrogen Fertilizers'

            # remove duplicates
            @fpcResult.data['nutrient_management_techniques'] = @fpcResult.data['nutrient_management_techniques'].filter((c, index) =>
                return @fpcResult.data['nutrient_management_techniques'].indexOf(c) is index)

    # Checks for uploaded pbi fields
    hasPBIUploadedConnection: (year) =>
        return @http.get('backend/grower/pbi/has-uploaded-pbi-connection', params: { year })

    # resets the 'Phosphorous soil test level' drop down and 'phosphorous drawdown strategy' section if the 'Conduct a soil test' yes/no button is set to No.
    resetDropDown: () =>
        @fpcResult.data['phosphorous_soil_test_level'] = null
        @fpcResult.data['phosphorous_drawdown_strategies'] = []

    # resets the 'phosphorous drawdown strategy' section if the 'Phosphorous soil test level' drop down is not set to Excessive/Very High
    resetDrawdown: () =>
        if @fpcResult.data['phosphorous_soil_test_level'] isnt 'Excessive/Very High'
            @fpcResult.data['phosphorous_drawdown_strategies'] = []

    downloadPdfs: (fpcResult = @fpcResult) =>
        url = new URL('/backend/grower/fieldprint/download-pdf', window.location.origin)
        url.searchParams.set('id', fpcResult.id)

        if fpcResult.dryland_response
            url.searchParams.set('type', 'dryland')
            window.open(url.toString())

        # don't download irrigated PDF if the user has since set irrigated to false
        if fpcResult.irrigated_response and fpcResult.data['irrigated']
            url.searchParams.set('type', 'irrigated')
            window.open(url.toString())

    goToFirstIncompleteStep: (id, skipNutrientManagementStep = false) =>
            # Go to the first incomplete step
        for step, index in Object.keys(@fpcResult.completeness.steps)
            if (not @fpcResult.completeness.steps[step] or not @fpcResult.saved_steps.includes(step))
                if skipNutrientManagementStep and step is 'Nutrient Management Tool(s)'
                    @gotoStep 0, id, false
                    return

                @gotoStep index, id, true, false, true
                return

        @gotoStep 0, id, false
